export default __webpack_public_path__ + "static/header-therapeutics-4d706889c8211d1f567325c886a84746.jpg";